export default "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?606b16427a59a5a97afbe8bb5f985394";